import { atom } from 'jotai';
import { cpOrderInvoicesSearchStateVM } from './cp_order_invoices_search_view_models';
import { CpOrderInvoicesSearchModel } from './cp_order_invoices_search_types';

export const cpOrderInvoicesSearchFormAtom = atom<CpOrderInvoicesSearchModel>(cpOrderInvoicesSearchStateVM());
